import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { isHasInsightsPermission, showInsights } from "../utils/MainHelper";

function useShowInsights() {
    const [showInsightsVal, setShowInsightsVal] = useState(false)
    const [hasInsightPermission, setHasInsightPermission] = useState(false)

    const { country } = useSelector((state) => state.buildTargets.setup);

    useEffect(() => {
        setShowInsightsVal(showInsights())
        setHasInsightPermission(isHasInsightsPermission())
    }, [country]);

    return {
        mustShowInsights: showInsightsVal && hasInsightPermission,
        showInsights: showInsightsVal,
        hasInsightPermission
    }
}

export default useShowInsights;
